const actions = {
    GET_USER_SIIGO_REQUEST: 'GET_USER_SIIGO_REQUEST',
    GET_USER_SIIGO_SUCCESS: 'GET_USER_SIIGO_SUCCESS',
    SET_CURRENT_USER_SIIGO: 'SET_CURRENT_USER_SIIGO',
    CLEAR_CURRENT_USER_SIIGO: 'CLEAR_CURRENT_USER_SIIGO',

    getSiigoUser: (id) => ({
        identification:id,
        type: actions.GET_USER_SIIGO_REQUEST
    })

};
export default actions;